import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function CreateSimpleCode({
    showSimpleCodeGroups,
    closeModal,
    refreshPage,
    groups
}) {
    const [formData, setFormData] = useState({
        simpleCodes: [
            { code: "", description1: "", description2: "" } // Initial single simple code with 'code' key
        ]
    });
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const resetForm = () => {
        setFormData({
            simpleCodes: [{ code: "", description1: "", description2: "" }] // Resetting with 'code'
        });
        setValidationError({});
    };

    useEffect(() => {
        console.log(groups, 88);
    }, [groups]);

    const handleChange = (e) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSimpleCodeChange = (index, field, value) => {
        const newSimpleCodes = [...formData.simpleCodes];
        newSimpleCodes[index][field] = value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            simpleCodes: newSimpleCodes,
        }));
    };

    const addSimpleCodeField = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            simpleCodes: [
                ...prevFormData.simpleCodes,
                { code: "", description1: "", description2: "" } // New field added with 'code'
            ],
        }));
    };

    const removeSimpleCodeField = (index) => {
        // Only allow removal if there's more than one set of fields
        if (formData.simpleCodes.length > 1) {
            const newSimpleCodes = formData.simpleCodes.filter((_, i) => i !== index);
            setFormData((prevFormData) => ({
                ...prevFormData,
                simpleCodes: newSimpleCodes,
            }));
        }
    };

    const dataToSubmit = {
        ...formData,
        group_id: groups?.id,
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await axiosInstance.post("/user/simple_code/create", dataToSubmit);
            toast.success("Simple Code(s) created successfully!");
            refreshPage();
            resetForm();
            handleClose();
        } catch (error) {
            console.error("Error submitting form:", error);
            if (error.response && error.response.data.errors) {
                setValidationError(error.response.data.errors);
                toast.error("Failed to save.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        resetForm();
        closeModal();
        refreshPage();
    };

    return (
        <Modal show={showSimpleCodeGroups} onHide={handleClose} dialogClassName="modal-md">
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h5>
                            Attach Simple Code to{" "}
                            <span>{groups?.name}</span>
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-2 p-2" style={{ border: '1px dotted rgba(0, 0, 0, 0.5)' }}>
                        {formData.simpleCodes.map((simpleCode, index) => (
                            <div key={index} className="mb-3">
                                <Form.Group>
                                    <Form.Label>
                                        <b>Simple Code {index + 1}</b>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Simple Code"
                                        value={simpleCode.code} // Now using 'code'
                                        onChange={(e) =>
                                            handleSimpleCodeChange(index, "code", e.target.value)
                                        }
                                        className="mb-2"
                                        isInvalid={validationError.simpleCodes && validationError.simpleCodes[index]?.code}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {validationError.simpleCodes && validationError.simpleCodes[index]?.code ? validationError.simpleCodes[index].code[0] : ''}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <br />
                                <Form.Group>
                                    <Form.Label>
                                        <b>Description1</b>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description 1"
                                        value={simpleCode.description1}
                                        onChange={(e) =>
                                            handleSimpleCodeChange(index, "description1", e.target.value)
                                        }
                                        className="mb-2"
                                    />
                                </Form.Group>
                                <br />
                                <Form.Group>
                                    <Form.Label>
                                        <b>Description2</b>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Description 2"
                                        value={simpleCode.description2}
                                        onChange={(e) =>
                                            handleSimpleCodeChange(index, "description2", e.target.value)
                                        }
                                        className="mb-2"
                                    />
                                </Form.Group>

                                <div className="d-flex justify-content-end text-end">
                                    <Button
                                        variant="danger"
                                        onClick={() => removeSimpleCodeField(index)}
                                        className="mt-2"
                                        disabled={formData.simpleCodes.length === 1} // Disable if only one set
                                    >
                                        <i className="ri-delete-bin-line"></i>
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button variant="secondary" onClick={addSimpleCodeField}>
                            Add Simple Code
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        style={{
                            backgroundColor: "#c4281b",
                            color: "#fff",
                            border: "none",
                        }}
                        type="submit"
                    >
                        Attach
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
